import { Settings } from "lucide-react"
import { Trigger } from "@/components/design-system"
import { useUIStore } from "@/stores/uiStore"

export function SettingsTrigger() {
  const openSettings = useUIStore((s) => s.openSettings)
  const settingsOpen = useUIStore((s) => s.isSettingsOpen)

  return (
    <Trigger
      id="settings-btn"
      icon={<Settings className="h-3.5 w-3.5" strokeWidth={1.5} />}
      label="Settings"
      active={settingsOpen}
      onClick={openSettings}
      size="sm"
    />
  )
}
